module.exports = __webpack_public_path__ + "static/media/image-card-1.2b1c5de8.png";